module.exports = {"TXTWCL_Your_voucher_amount":{"id":"TXTWCL_Your_voucher_amount","defaultMessage":"Dein Voucherbetrag","track":"Your voucher amount"}}